import React, { useEffect, useState } from 'react';

import { TimerBlock } from '../styles';
import { ActionsRow, ButtonLabelBox } from './styles';

import { Button } from '@/shared/ui/form/button/button';

import { BodyTextMediumB } from '@/shared/ui/typography2';
import { formatDuration, intervalToDuration } from 'date-fns';
import { de, enUS, es, kk, pt, ro, ru, uk, uz } from 'date-fns/locale';
import { useScopedI18n } from '@locales/client';
import { isBonusActive } from '@/flat-pages/bonuses/model/utils';

interface IProps {
  bonus: any;
  t: any;
  locale: string;
  updateDate: any;
}

const daysFormat = ['days', 'hours'];
const hoursFormat = ['hours', 'minutes'];
const minutesFormat = ['minutes', 'seconds'];
const locales = {
  de: de,
  en: enUS,
  es: es,
  kz: kk,
  pt: pt,
  ro: ro,
  ru: ru,
  uk: uk,
  uz: uz,
};

export const BonusActions = ({ bonus, t, locale, updateDate }: IProps) => {
  const tWeekDays = useScopedI18n('bonus.card.week_days');
  const tCard = useScopedI18n('bonus.card');
  const [message, setMessage] = useState<string>('');
  const isEnabled = isBonusActive(bonus);
  const isActive = bonus.state == 'active';

  useEffect(() => {
    function tick() {
      const nowDate = new Date();
      const bonusTimer = new Date(1000 * bonus.timer);
      if (bonusTimer < nowDate) {
        updateDate();
        return;
      }

      const state: string = bonus.state;

      if (state.startsWith('weekday')) {
        const weekDay = parseInt(state.substring(7, 9));
        if (weekDay !== nowDate.getDay()) {
          setMessage(tWeekDays(weekDay));
          return;
        }
      }
      const duration = intervalToDuration({
        end: bonusTimer,
        start: nowDate,
      });
      const formatted = formatDuration(duration, {
        format:
          duration.days > 0
            ? daysFormat
            : duration.hours > 0
              ? hoursFormat
              : minutesFormat,
        locale: locales[locale],
      });
      setMessage(formatted);
    }

    const needTimer =
      bonus.state != 'not_logged' && bonus.state != 'need_deposits';
    // const needTimer = bonus.state == 'available' || bonus.state == 'active';
    const countdown = needTimer ? setInterval(tick, 1000) : null;
    if (needTimer) {
      tick();
    }

    if (!countdown) {
      if (bonus.state === 'not_logged') {
        setMessage(tCard('not_logged'));
        return;
      } else if (bonus.state === 'need_deposits') {
        setMessage(tCard('need_deposits', { value: bonus.depositCount }));
        return;
      }
    }

    return () => {
      if (countdown) {
        clearInterval(countdown);
      }
    };
  }, [bonus.timer, locale, isEnabled, bonus.state]);

  return (
    <ActionsRow>
      {isEnabled && (
        <Button
          $flex="none"
          variant={isActive ? 'greenBlueGradient' : 'yellowGradient'}
        >
          <ButtonLabelBox>
            <BodyTextMediumB color={isActive ? '#FFF' : '#2A2A2A'}>
              {t(
                isActive
                  ? 'card.active_button_play'
                  : 'card.active_button_label'
              )}
            </BodyTextMediumB>
          </ButtonLabelBox>
        </Button>
      )}
      <TimerBlock>
        <BodyTextMediumB
          style={{
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 1,
            alignSelf: 'stretch',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            lineHeight: '40px',
          }}
        >
          {message}
        </BodyTextMediumB>
      </TimerBlock>
    </ActionsRow>
  );
};
